/** Keep the existing format: "<sequence> <UE code>"; gaps must not create duplicates. */
export function suggestEcuCode(codeUE: string, ecus: { codeECU?: string }[] = []): string {
  const maximum = ecus.reduce((max, ecu) => {
    const match = ecu.codeECU?.trim().match(/^(\d+)\s+(.+)$/);
    return match && match[2] === codeUE.trim() ? Math.max(max, Number(match[1])) : max;
  }, 0);
  return `${maximum + 1} ${codeUE.trim()}`;
}
